import React from 'react'
import MuiTextField from '@mui/material/TextField'
import { showErrorToast } from '@/shared/toast/toast.helper'
import BaseDisplayItem, {
    BaseDisplayItemProps,
    DisplayItemBase,
    DisplayMode,
} from '@/feature/DisplayItems/BaseDisplayItem'

/* ---------- Types ---------- */

interface ItemSettings {
    phone_number?: boolean
    fill_dossier_id?: boolean
}

interface Item extends DisplayItemBase {
    settings?: ItemSettings
    mode?: DisplayMode
}

interface Kedo {
    t: (key: string) => string
}

interface Props extends BaseDisplayItemProps<string, Item> {
    kedo: Kedo
    onKeyPress?: (
        itemOrId: Item | Item['id'],
        event: React.KeyboardEvent<HTMLInputElement>
    ) => void
}

/* ---------- Component ---------- */

class TextField extends BaseDisplayItem<string, Item, HTMLInputElement> {
    constructor(props: Props) {
        super(props)
        this.onChange = this.onChange.bind(this)
    }

    /* ---------- Change ---------- */

    onChange(event: React.ChangeEvent<HTMLInputElement>) {
        const value = event.target.value

        // Use BaseDisplayItem.updateValue to keep state + parent in sync
        this.updateValue(value)

        if (value.length >= 255) {
            showErrorToast(
                (this.props as Props).kedo.t('dossier_errors.maxLength_edit')
            )
        }
    }

    /* ---------- Render: SHOW ---------- */

    renderShow(): React.ReactNode {
        const props = this.props as Props

        if (!props.value) return null

        if (this.getSetting<boolean>('phone_number')) {
            return <a href={`tel:${props.value}`}>{props.value}</a>
        }

        return props.value
    }

    renderEdit(): React.ReactNode {
        const props = this.props as Props

        if (
            this.getSetting<boolean>('fill_dossier_id', {
                defaultValue: false,
                source: 'item',
            }) === true
        )
            return null

        return (
            <MuiTextField
                size="small"
                fullWidth
                inputRef={this.innerRef}
                value={this.state.value ?? ''}
                error={this.isInvalid()}
                helperText={this.isInvalid() ? this.getErrorText() : ''}
                onChange={this.onChange}
                onKeyPress={
                    props.onKeyPress
                        ? (e) => props.onKeyPress!(props.item, e)
                        : undefined
                }
                inputProps={{ maxLength: 255 }}
            />
        )
    }

    renderSearch(): React.ReactNode {
        const props = this.props as Props

        return (
            <MuiTextField
                size="small"
                fullWidth
                type="text"
                value={props.value ?? ''}
                onChange={(e) =>
                    props.changeValue?.(
                        props.item.id,
                        e.target.value,
                        props.item
                    )
                }
                onKeyPress={
                    props.onKeyPress
                        ? (e) => props.onKeyPress!(props.item.id, e)
                        : undefined
                }
            />
        )
    }
}

export default TextField
